import Clear from '../layouts/Clear.vue';

export default {
  path: '/reports',
  component: Clear,
  children: [
    {
      path: '',
      name: 'reports.index',
      component: () => import('@/views/report/platformReport.vue'),
    },
  ],
};
